var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#FF8051"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.452 48.506C23.0001 48.506 22.5501 48.3815 22.1492 48.1336C21.4127 47.6786 20.9733 46.89 20.9733 46.024V42.3898C18.3799 39.1041 17.2591 35.0009 17.8149 30.7903C18.706 24.0348 24.2583 18.4978 31.0162 17.6254C35.7762 17.0105 40.4486 18.5707 43.8406 21.9035C47.2328 25.2363 48.8741 29.8772 48.3446 34.637C47.5773 41.5302 42.0109 47.2011 35.1099 48.1217C32.3587 48.4866 29.5762 48.1057 27.0235 47.0123L24.5626 48.2419C24.2101 48.418 23.8301 48.506 23.452 48.506ZM31.2973 19.8057C25.5104 20.5527 20.7564 25.2933 19.9928 31.0778C19.5009 34.8088 20.5392 38.4387 22.917 41.2974C23.081 41.4947 23.1707 41.7436 23.1707 42.0001V46.024C23.1707 46.1537 23.2438 46.2256 23.3043 46.2644C23.3666 46.3018 23.4648 46.334 23.5802 46.276L26.5072 44.8136C26.8068 44.6633 27.1607 44.6581 27.4655 44.8017C29.7683 45.8823 32.3102 46.2772 34.8189 45.9436C40.7335 45.1547 45.503 40.2973 46.1607 34.3945C46.6152 30.3095 45.2079 26.3275 42.3001 23.4712C39.3927 20.6137 35.3825 19.2767 31.2973 19.8057ZM31.1567 18.7155H31.1674H31.1567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4227 36.3521L30.4666 29.1733C30.6767 28.8056 31.1613 28.7055 31.4998 28.9594L34.8788 31.4934C35.1078 31.6652 35.4178 31.6811 35.6631 31.5339L39.7777 28.6256C40.3815 28.2633 41.0839 28.914 40.7693 29.5438L36.6959 36.5915C36.5125 36.9583 36.0559 37.0912 35.7043 36.8802L31.1934 34.1737C30.9871 34.0499 30.7318 34.04 30.5165 34.1476L26.3483 37.3304C25.7258 37.642 25.0772 36.9566 25.4227 36.3521Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.012,
    height: 31.012,
    fill: "white",
    transform: "translate(17.4941 17.4939)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallback);
export default __webpack_public_path__ + "static/media/callback.ceff706cfbbb769e99db7c8fb5803700.svg";
export { ForwardRef as ReactComponent };